<template>
  <div class="app_wrapper">
    <sidebar />
    <div class="app_container">
      <div class="app_fixed_header">
        <navbar />
        <tags-view />
      </div>
      <app-main />

      <div class="app_privilege_btns" v-if="isPrivilegeUser">
        <el-button type="info" @click="changeUserPrivilegeStatus(0)">{{$ts('取消')}}</el-button>
        <el-button type="success" @click="changeUserPrivilegeStatus(1)">{{$ts('保存')}}</el-button>
      </div>
    </div>

    <!-- 平台过期弹窗 -->
    <plat-expire ref="platExpire" />
    <!-- 翻译添加/编辑弹窗 -->
    <plat-locale ref="platLocale" />
  </div>
</template>

<script>
  import {
    Sidebar,
    Navbar,
    AppMain,
    TagsView
  } from '@/components/layout'
  import platExpire from '@/components/modal/plat-expire.vue';
  import platLocale from '@/components/modal/plat-locale.vue';
  import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  import {
    debounceFn
  } from '@/assets/js/tool.js'
  import Vue from 'vue'
  export default {
    name: 'layout',
    components: {
      AppMain,
      Navbar,
      Sidebar,
      TagsView,
      platExpire,
      platLocale
    },
    data() {
      return {
        userPrivilegeData: null,
        userPrivilegeSave: []
      }
    },
    computed: {
      ...mapState(['serviceTime', 'isPrivilegeUser', 'userPrivilege']),
      ...mapGetters(['userInfo'])
    },
    beforeMount() {
      window.addEventListener('resize', this.resizeHandler)
    },
    beforeDestroy() {
      this.$bus.$off('editUserPrivilege', this.editUserPrivilege)
      window.removeEventListener('resize', this.resizeHandler)
    },
    mounted() {
      Vue.prototype.showPlatLocale = this.showPlatLocale;
      this.$bus.$on('editUserPrivilege', this.editUserPrivilege)
      this.getSysCfg()
      this.getUpdateList()
    },
    methods: {
      ...mapMutations(['SET_STATE', 'SET_STATE_VAL']),
      ...mapActions(['getSystem']),
      // 翻译弹窗
      showPlatLocale(source, type, title, input_type, callback) {
        this.$refs.platLocale.show({
          source,
          type,
          title,
          input_type,
          callback
        })
      },
      // 监听
      editUserPrivilege(data) {
        this.userPrivilegeSave = this.userPrivilege;
        let userPrivilege = data.page_auth ? JSON.parse(data.page_auth) : [];
        this.userPrivilegeData = data;
        this.SET_STATE({
          isPrivilegeUser: true,
          userPrivilege: userPrivilege
        })
        this.navTo('/manager-welcome')
      },
      // 取消、保存个人角色编辑
      changeUserPrivilegeStatus(type) {
        if (type == 1 && this.userPrivilegeData) {
          this.$confirm(this.$ts('确认保存角色权限?'), this.$ts('保存'), {
            confirmButtonText: this.$ts('保存'),
            cancelButtonText: this.$ts('取消')
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.request({
              url: '/admin/department/setRolePageAuth',
              data: {
                id: this.userPrivilegeData.id,
                auth: JSON.stringify(this.userPrivilege)
              },
              is_public: true,
              complete: (res) => {
                loading.close();
                if (res.error_code == 0) {
                  this.$message.success(this.$ts('操作成功'))
                  this.SET_STATE({
                    isPrivilegeUser: false,
                    userPrivilege: this.userPrivilegeSave
                  })
                  this.navTo('/role-list')
                } else {
                  this.$message.error(res.error_msg)
                }
              }
            })
          }).catch(() => {})
        } else {
          this.SET_STATE({
            isPrivilegeUser: false,
            userPrivilege: this.userPrivilegeSave
          })
          this.navTo('/role-list')
        }
      },
      /**
       * 监听页面变化 获取可视宽度
       * */
      resizeHandler: debounceFn(function() {
        this.SET_STATE({
          clientWidth: Math.floor(document.body.getBoundingClientRect().width)
        })
      }),
      /*
       * 获取系统配置信息
       */
      getSysCfg() {
        this.SET_STATE_VAL({
          order_print_set: {
            table_name: `《${this.$ts('业务订单')}》`
          },
          complate_delivery_main: {
            table_name: `《${this.$ts('送货单')}》`
          },
          warehouse_receipt_print_set: {
            table_name: `《${this.$ts('入库单')}》`
          }
        })
        this.SET_STATE({
          complateNameTip: this.$ts('模板')
        })
        this.getSystem(1).then((data) => {
          let platExpireData = this.getLocalStorage('platExpire') || {
            alert: true,
            date: ''
          };
          let nowDate = new Date(this.serviceTime * 1000).format('Y-M-D');
          let days = Math.floor((this.userInfo.plat_expire_time - this.serviceTime) / 86400);
          if (platExpireData.date != nowDate && days <= 30) {
            if (days == 15 || days == 30) {
              platExpireData.alert = true;
            }
            this.alertExpire(days, platExpireData)
          }
        })
      },
      // 过期时间弹窗
      alertExpire(days, platExpireData) {
        if (platExpireData.alert) {
          let nowDate = new Date(this.serviceTime * 1000).format('Y-M-D');
          platExpireData.date = nowDate;
          this.$refs.platExpire.show({
            days,
            expire_time: new Date(this.userInfo.plat_expire_time * 1000).format('Y-M-D'),
            platExpireData
          })
        }
      },
      /**
       * 获取更新内容 第一条
       * */
      getUpdateList() {
        this.request({
          url: "/api/article/articlelist",
          data: {
            page: 1,
            type: 73,
            page_num: 1,
          },
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              let list = res.data;
              if (list.length) {
                let updateData = list[0];
                let dataTime = updateData.create_time * 1000;
                if (Date.now() - dataTime < 1 * 24 * 3600 * 1000) {
                  this.$notify({
                    title: updateData.title,
                    dangerouslyUseHTMLString: true,
                    customClass: 'page_notification',
                    message: updateData.content,
                    duration: 0,
                    onClick(e) {
                      window.open(
                        this.url + "/manager/#/news-content?type=产品&id=" + updateData.id
                      );
                    }
                  });
                }
              }
            }
          },
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .app {
    &_wrapper {
      display: flex;
    }

    &_container {
      flex: 1 0 0;
      height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &_privilege_btns {
      position: absolute;
      top: 84px;
      right: 4px;
      z-index: 30;
    }
  }
</style>

<style lang="scss">
  /* ----- 老版本样式 -----*/
  /* 调整 -tom */
  .router-container {
    height: 100%;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: '-moz-scrollbars-none';
    scrollbar-width: none;
  }

  .router-container::-webkit-scrollbar {
    display: none;
    /*  Chrome  */
    width: 0 !important;
    /*  Chrome  */
  }

  /* end */
  .wrapper {
    position: relative;
    overflow: hidden;
  }

  .content {
    padding: 10px;
  }

  .tags~.content {
    height: calc(100% - 40px);
  }

  .content-box {
    top: 45px;
    left: 200px;
  }

  .content-collapse {
    left: 0;
  }

  .container {
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 0 0 90px;
    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: '-moz-scrollbars-none';
    scrollbar-width: none;
  }

  .container::-webkit-scrollbar {
    display: none;
    /*  Chrome  */
    width: 0 !important;
    /*  Chrome  */
  }

  /**
   * 右边隐藏
   */
  .isShowStyle {
    display: none;
  }

  /* 面包屑 */
  .content-header {
    background: #f5f8f9;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #a7a7a7;
  }

  /* pc端：分页器 */
  .paginat {
    margin-top: 10px;
    text-align: center;
  }

  /* 手机端：功能按钮区 */
  .slidbar {
    display: none !important;
  }

  /* 手机端：筛选框 */
  .drawer-demo {
    padding: 20px;
    width: 80%;
    height: 100%;
  }

  .drawer_footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
  }

  .content::-webkit-scrollbar,
  .el-main::-webkit-scrollbar {
    width: 0;
  }

  .row-info {
    display: flex;
  }

  .info-list {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* 固定底部按钮区 */
  .bottom-button {
    position: absolute;
    bottom: 0;
    left: 10px;
    text-align: left;
    background: #fff;
    width: 100%;
    padding: 20px;
    border-top: 1px solid #f0f0f0;
    box-sizing: border-box;
    z-index: 40;
  }

  .el-backtop {
    z-index: 41;
  }

  .mobileStyle {
    display: initial;
  }
</style>



// WEBPACK FOOTER //
// src/views/manager/index.vue